import { useEffect } from "react";
import "./User.scss";
import { useNavigate, useParams } from "react-router-dom";
import { LocalStorageKeys } from "../../models/LocalStorageKeys";
import Logo from "../Logo/Logo";

export default function ResetTokenForm() {
  const navigate = useNavigate();

  useEffect(() => {

    if (window.confirm('Are you DOUBLE sure you want to reset your player token?')) {
      localStorage.setItem(LocalStorageKeys.TOKEN_KEY, '');
      // can leave name value after reworking new player form
      localStorage.setItem(LocalStorageKeys.NAME_KEY, '');
      navigate(`/`, { replace: true });
      window.location.reload();
    }
  }, [navigate]);

  return (
    <>
      <Logo></Logo>
    </>
  );
}